import { ItemType } from "../defines/enums"
import { EquippableItem } from "../defines/types"
import { EquipmentDefaults } from "../defines/values"

export function getEquipment(type: ItemType): EquippableItem | undefined {
  switch (type) {
    case ItemType.EQUIPMENT_HEAD_NONE:
      return EquipmentDefaults.HEAD.HEAD_NONE
    case ItemType.EQUIPMENT_HEAD1:
      return EquipmentDefaults.HEAD.HEAD1
    case ItemType.EQUIPMENT_HEAD2:
      return EquipmentDefaults.HEAD.HEAD2
    case ItemType.EQUIPMENT_HEAD3:
      return EquipmentDefaults.HEAD.HEAD3
    case ItemType.EQUIPMENT_HEAD4:
      return EquipmentDefaults.HEAD.HEAD4
    case ItemType.EQUIPMENT_HEAD5:
      return EquipmentDefaults.HEAD.HEAD5
    case ItemType.EQUIPMENT_HEAD6:
      return EquipmentDefaults.HEAD.HEAD6
    case ItemType.EQUIPMENT_HEAD7:
      return EquipmentDefaults.HEAD.HEAD7
    case ItemType.EQUIPMENT_HEAD8:
      return EquipmentDefaults.HEAD.HEAD8

    case ItemType.EQUIPMENT_TORSO_NONE:
      return EquipmentDefaults.TORSO.TORSO_NONE
    case ItemType.EQUIPMENT_TORSO1:
      return EquipmentDefaults.TORSO.TORSO1
    case ItemType.EQUIPMENT_TORSO2:
      return EquipmentDefaults.TORSO.TORSO2
    case ItemType.EQUIPMENT_TORSO3:
      return EquipmentDefaults.TORSO.TORSO3
    case ItemType.EQUIPMENT_TORSO4:
      return EquipmentDefaults.TORSO.TORSO4
    case ItemType.EQUIPMENT_TORSO5:
      return EquipmentDefaults.TORSO.TORSO5
    case ItemType.EQUIPMENT_TORSO6:
      return EquipmentDefaults.TORSO.TORSO6
    case ItemType.EQUIPMENT_TORSO7:
      return EquipmentDefaults.TORSO.TORSO7
    case ItemType.EQUIPMENT_TORSO8:
      return EquipmentDefaults.TORSO.TORSO8

    case ItemType.EQUIPMENT_FEET_NONE:
      return EquipmentDefaults.FEET.FEET_NONE
    case ItemType.EQUIPMENT_FEET1:
      return EquipmentDefaults.FEET.FEET1
    case ItemType.EQUIPMENT_FEET2:
      return EquipmentDefaults.FEET.FEET2
    case ItemType.EQUIPMENT_FEET3:
      return EquipmentDefaults.FEET.FEET3
    case ItemType.EQUIPMENT_FEET4:
      return EquipmentDefaults.FEET.FEET4
    case ItemType.EQUIPMENT_FEET5:
      return EquipmentDefaults.FEET.FEET5
    case ItemType.EQUIPMENT_FEET6:
      return EquipmentDefaults.FEET.FEET6
    case ItemType.EQUIPMENT_FEET7:
      return EquipmentDefaults.FEET.FEET7
    case ItemType.EQUIPMENT_FEET8:
      return EquipmentDefaults.FEET.FEET8

    case ItemType.EQUIPMENT_GIZMO_NONE:
      return EquipmentDefaults.GIZMO.GIZMO_NONE
    case ItemType.EQUIPMENT_GIZMO1:
      return EquipmentDefaults.GIZMO.GIZMO1
    case ItemType.EQUIPMENT_GIZMO2:
      return EquipmentDefaults.GIZMO.GIZMO2
    case ItemType.EQUIPMENT_GIZMO3:
      return EquipmentDefaults.GIZMO.GIZMO3
    case ItemType.EQUIPMENT_GIZMO4:
      return EquipmentDefaults.GIZMO.GIZMO4
    case ItemType.EQUIPMENT_GIZMO5:
      return EquipmentDefaults.GIZMO.GIZMO5

    case ItemType.EQUIPMENT_WEAPON_NONE:
      return EquipmentDefaults.WEAPON.WEAPON_NONE
    case ItemType.EQUIPMENT_WEAPON1:
      return EquipmentDefaults.WEAPON.WEAPON1
    case ItemType.EQUIPMENT_WEAPON2:
      return EquipmentDefaults.WEAPON.WEAPON2
    case ItemType.EQUIPMENT_WEAPON3:
      return EquipmentDefaults.WEAPON.WEAPON3
    case ItemType.EQUIPMENT_WEAPON4:
      return EquipmentDefaults.WEAPON.WEAPON4
    case ItemType.EQUIPMENT_WEAPON5:
      return EquipmentDefaults.WEAPON.WEAPON5
    case ItemType.EQUIPMENT_WEAPON6:
      return EquipmentDefaults.WEAPON.WEAPON6
    case ItemType.EQUIPMENT_WEAPON7:
      return EquipmentDefaults.WEAPON.WEAPON7
  }
  return undefined
}

export function isEquipment(item: ItemType): boolean {
  return isWardrobe(item) || isWeapon(item) || isGizmo(item)
}

export function isWardrobe(item: ItemType): boolean {
  return (
    isHeadEquipment(item) || isTorsoEquipment(item) || isFeetEquipment(item)
  )
}

export function isWeapon(item: ItemType): boolean {
  switch (item) {
    case ItemType.EQUIPMENT_WEAPON_NONE:
    case ItemType.EQUIPMENT_WEAPON1:
    case ItemType.EQUIPMENT_WEAPON2:
    case ItemType.EQUIPMENT_WEAPON3:
    case ItemType.EQUIPMENT_WEAPON4:
    case ItemType.EQUIPMENT_WEAPON5:
    case ItemType.EQUIPMENT_WEAPON6:
    case ItemType.EQUIPMENT_WEAPON7:
      return true
  }
  return false
}

export function isGizmo(item: ItemType): boolean {
  switch (item) {
    case ItemType.EQUIPMENT_GIZMO_NONE:
    case ItemType.EQUIPMENT_GIZMO1:
    case ItemType.EQUIPMENT_GIZMO2:
    case ItemType.EQUIPMENT_GIZMO3:
    case ItemType.EQUIPMENT_GIZMO4:
    case ItemType.EQUIPMENT_GIZMO5:
    case ItemType.EQUIPMENT_GIZMO6:
      return true
  }
  return false
}

export function isHeadEquipment(item: ItemType): boolean {
  switch (item) {
    case ItemType.EQUIPMENT_HEAD_NONE:
    case ItemType.EQUIPMENT_HEAD1:
    case ItemType.EQUIPMENT_HEAD2:
    case ItemType.EQUIPMENT_HEAD3:
    case ItemType.EQUIPMENT_HEAD4:
    case ItemType.EQUIPMENT_HEAD5:
    case ItemType.EQUIPMENT_HEAD6:
    case ItemType.EQUIPMENT_HEAD7:
    case ItemType.EQUIPMENT_HEAD8:
      return true
  }

  return false
}

export function isTorsoEquipment(item: ItemType): boolean {
  switch (item) {
    case ItemType.EQUIPMENT_TORSO_NONE:
    case ItemType.EQUIPMENT_TORSO1:
    case ItemType.EQUIPMENT_TORSO2:
    case ItemType.EQUIPMENT_TORSO3:
    case ItemType.EQUIPMENT_TORSO4:
    case ItemType.EQUIPMENT_TORSO5:
    case ItemType.EQUIPMENT_TORSO6:
    case ItemType.EQUIPMENT_TORSO7:
    case ItemType.EQUIPMENT_TORSO8:
      return true
  }

  return false
}

export function isFeetEquipment(item: ItemType): boolean {
  switch (item) {
    case ItemType.EQUIPMENT_FEET_NONE:
    case ItemType.EQUIPMENT_FEET1:
    case ItemType.EQUIPMENT_FEET2:
    case ItemType.EQUIPMENT_FEET3:
    case ItemType.EQUIPMENT_FEET4:
    case ItemType.EQUIPMENT_FEET5:
    case ItemType.EQUIPMENT_FEET6:
    case ItemType.EQUIPMENT_FEET7:
    case ItemType.EQUIPMENT_FEET8:
      return true
  }

  return false
}
